/* Strade — behaviour for the ALDO-style sections. No dependencies. */
(function () {
  'use strict';

  var S = (window.Strade = window.Strade || {});
  var C = S.config || { routes: {}, strings: {} };
  var R = C.routes || {};
  var T = C.strings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  // Panels opened from inside a section (size guide, image zoom) are moved to <body> so they always
  // sit above the sticky header; sections with fade-in effects would otherwise trap them underneath.
  function toBody(node) {
    if (!node || node.parentNode === document.body) return;
    if (node.id) { var old = document.getElementById(node.id); if (old && old !== node && old.parentNode === document.body) old.remove(); }
    document.body.appendChild(node);
  }
  function onReady(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* ---------------- money ---------------- */
  S.money = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || C.moneyFormat || '${{amount}}';
    function fmt(n, dec, th, ds) {
      th = th == null ? ',' : th; ds = ds == null ? '.' : ds;
      var num = (n / 100).toFixed(dec);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return parts[1] ? whole + ds + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2);
      }
    });
  };

  /* ---------------- toast ---------------- */
  var toastEl, toastTimer;
  // S.toast(message, { label: 'Undo', onClick: fn }) shows an optional action button
  S.toast = function (msg, action) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'st-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.toggle('has-action', !!action);
    if (action) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'st-toast__action';
      b.textContent = action.label;
      b.addEventListener('click', function () { toastEl.classList.remove('is-on'); action.onClick(); });
      toastEl.appendChild(b);
    }
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, action ? 6000 : 2400);
  };

  /* ---------------- overlays (drawers, search, zoom) ---------------- */
  var scrim, openEl = null, lastTrigger = null;
  function ensureScrim() {
    if (scrim) return scrim;
    scrim = document.createElement('div');
    scrim.className = 'st-scrim';
    scrim.addEventListener('click', function () { S.close(); });
    document.body.appendChild(scrim);
    return scrim;
  }
  // Horizon scrolls inside .page-wrapper instead of the window, so read and lock both.
  function pageWrapper() { return document.querySelector('.page-wrapper'); }
  function scrollY() { var pw = pageWrapper(); return window.scrollY + (pw ? pw.scrollTop : 0); }
  S.scrollY = scrollY;
  function onPageScroll(fn) {
    window.addEventListener('scroll', fn, { passive: true });
    var pw = pageWrapper();
    if (pw) pw.addEventListener('scroll', fn, { passive: true });
  }
  function lockScroll(on) {
    var html = document.documentElement;
    if (on) {
      html.setAttribute('scroll-lock', '');
      document.body.classList.add('st-lock');
    } else {
      html.removeAttribute('scroll-lock');
      document.body.classList.remove('st-lock');
    }
  }
  S.open = function (el, trigger) {
    if (typeof el === 'string') el = document.querySelector(el);
    if (!el) return;
    if (openEl && openEl !== el) S.close(true);
    ensureScrim();
    // keep the scrim in the same stacking context as the panel it sits under
    if (scrim.nextElementSibling !== el) el.parentNode.insertBefore(scrim, el);
    openEl = el;
    lastTrigger = trigger || document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    el.removeAttribute('inert');
    if (!el.hasAttribute('data-no-scrim')) scrim.classList.add('is-on');
    lockScroll(true);
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusFirst = function () {
      if (openEl !== el || el.contains(document.activeElement)) return;
      var f = el.querySelector('[data-autofocus]') || el.querySelector('input:not([type=hidden]), button, a[href], select, textarea');
      if (f) f.focus({ preventScroll: true });
    };
    setTimeout(focusFirst, 40);
    // second try once the slide-in has finished (the panel can't take focus while still hidden)
    setTimeout(focusFirst, 360);
    el.dispatchEvent(new CustomEvent('st:open', { bubbles: true }));
  };
  S.close = function (silent) {
    if (!openEl) return;
    var el = openEl;
    openEl = null;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('inert', '');
    if (scrim) scrim.classList.remove('is-on');
    lockScroll(false);
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    el.dispatchEvent(new CustomEvent('st:close', { bubbles: true }));
    if (!silent && lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
  };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (openEl) { S.close(); return; }
      $$('.st-nav__item.is-open').forEach(function (i) { closeMega(i); });
      $$('.st-qa.is-open').forEach(function (q) { q.classList.remove('is-open'); });
    }
    if (e.key === 'Tab' && openEl) {
      var f = $$('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', openEl).filter(function (x) { return x.offsetParent !== null || x === document.activeElement; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-st-open]');
    if (o) {
      var target = document.querySelector(o.getAttribute('data-st-open'));
      if (target) { e.preventDefault(); S.open(target, o); }
      return;
    }
    var c = e.target.closest('[data-st-close]');
    if (c) { e.preventDefault(); S.close(); }
  });

  /* ---------------- header ---------------- */
  function headerHost() {
    var w = $('.st-header-wrap');
    return w ? (w.closest('.shopify-section') || w) : null;
  }
  function setHeaderHeight() {
    var host = headerHost();
    var h = 0;
    if (host && host.classList.contains('is-sticky') && !host.classList.contains('is-hidden')) h = $('.st-header', host).offsetHeight;
    document.documentElement.style.setProperty('--st-header-h', h + 'px');
  }
  function initHeader(root) {
    var inner = $('.st-header-wrap', root) || (root.classList && root.classList.contains('st-header-wrap') ? root : null);
    if (!inner || inner.dataset.ready) return;
    inner.dataset.ready = '1';
    var wrap = inner.closest('.shopify-section') || inner;
    var mode = inner.dataset.sticky;
    wrap.classList.add('st-header-section');
    wrap.classList.toggle('is-sticky', mode === 'always' || mode === 'scroll-up');
    var lastY = scrollY();
    var ticking = false;
    function onScroll() {
      var y = scrollY();
      wrap.classList.toggle('is-scrolled', y > 4);
      if (mode === 'scroll-up') {
        var hide = y > lastY && y > wrap.offsetHeight + 60 && !openEl && !$('.st-nav__item.is-open', wrap);
        if (y < lastY - 4 || y < 10) hide = false;
        if (hide !== wrap.classList.contains('is-hidden')) { wrap.classList.toggle('is-hidden', hide); setHeaderHeight(); }
      }
      lastY = y;
      ticking = false;
    }
    onPageScroll(function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } });
    window.addEventListener('resize', debounce(setHeaderHeight, 100));
    setHeaderHeight();

    // mega menu: hover intent on mouse, click/Enter on keyboard and touch
    $$('.st-nav__item[data-mega]', wrap).forEach(function (item) {
      var link = $('.st-nav__link', item);
      var openT, closeT;
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeT);
        openT = setTimeout(function () {
          $$('.st-nav__item.is-open', wrap).forEach(function (o) { if (o !== item) closeMega(o); });
          openMega(item);
        }, $('.st-nav__item.is-open', wrap) ? 0 : 90);
      });
      item.addEventListener('mouseleave', function () { clearTimeout(openT); closeT = setTimeout(function () { closeMega(item); }, 140); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) closeMega(item); });
      link.addEventListener('click', function (e) {
        var touch = window.matchMedia('(hover: none)').matches;
        if (touch && !item.classList.contains('is-open')) { e.preventDefault(); openMega(item); }
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || (e.key === ' ')) { e.preventDefault(); openMega(item); var f = $('.st-mega a', item); if (f) f.focus(); }
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.st-nav__item')) $$('.st-nav__item.is-open', wrap).forEach(closeMega); });

    // mobile menu panels
    var mm = $('.st-mm', wrap) || $('.st-mm');
    if (mm) {
      mm.addEventListener('click', function (e) {
        var next = e.target.closest('[data-mm-next]');
        var back = e.target.closest('[data-mm-back]');
        if (next) {
          var p = document.getElementById(next.getAttribute('data-mm-next'));
          if (!p) return;
          var current = next.closest('.st-mm__panel');
          current.classList.add('is-behind');
          p.classList.add('is-active');
          p.dataset.parent = current.id;
          var f = $('.st-mm__back', p); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 30);
        }
        if (back) {
          var panel = back.closest('.st-mm__panel');
          panel.classList.remove('is-active');
          var parent = document.getElementById(panel.dataset.parent);
          if (parent) parent.classList.remove('is-behind');
        }
      });
      var drawer = mm.closest('.st-drawer');
      if (drawer) drawer.addEventListener('st:close', function () {
        setTimeout(function () {
          $$('.st-mm__panel', mm).forEach(function (p) { p.classList.remove('is-active', 'is-behind'); });
        }, 300);
      });
    }
  }
  function openMega(item) { item.classList.add('is-open'); var l = $('.st-nav__link', item); if (l) l.setAttribute('aria-expanded', 'true'); }
  function closeMega(item) { item.classList.remove('is-open'); var l = $('.st-nav__link', item); if (l) l.setAttribute('aria-expanded', 'false'); }

  /* ---------------- promo bar rotation ---------------- */
  function initPromo(root) {
    $$('[data-st-promo]', root).forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var msgs = $$('.st-promo__msg', bar);
      if (msgs.length < 2) return;
      var i = 0, speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000, paused = false;
      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, speed);
    });
  }

  /* ---------------- rails ---------------- */
  function initRails(root) {
    $$('[data-st-rail]', root).forEach(function (rail) {
      if (rail.dataset.ready) return;
      rail.dataset.ready = '1';
      var track = $('[data-st-track]', rail);
      var prev = $('[data-st-prev]', rail);
      var next = $('[data-st-next]', rail);
      var bar = $('.st-progress i', rail.parentNode);
      if (!track) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        if (bar) {
          var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
          bar.style.setProperty('--p', Math.min(100, ratio * 100) + '%');
          bar.style.setProperty('--x', (max > 0 ? (track.scrollLeft / max) * ((1 / ratio) - 1) * 100 : 0) + '%');
        }
      }
      function step(dir) {
        var item = track.firstElementChild;
        var w = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
        var per = Math.max(1, Math.floor(track.clientWidth / w));
        track.scrollBy({ left: dir * w * per, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', debounce(update, 100));
      update();
      setTimeout(update, 400);
    });
  }

  /* ---------------- slideshow ---------------- */
  function initSlideshows(root) {
    $$('[data-st-slideshow]', root).forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var slides = $$('.st-slide', el);
      var dots = $$('.st-hero__dot', el);
      if (slides.length < 2) return;
      var i = 0, timer = null;
      var auto = el.dataset.autoplay === 'true';
      var speed = (parseInt(el.dataset.speed, 10) || 6) * 1000;
      function go(n) {
        slides[i].classList.remove('is-on'); slides[i].setAttribute('aria-hidden', 'true');
        if (dots[i]) { dots[i].classList.remove('is-on'); dots[i].setAttribute('aria-current', 'false'); }
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-on'); slides[i].setAttribute('aria-hidden', 'false');
        if (dots[i]) { dots[i].classList.add('is-on'); dots[i].setAttribute('aria-current', 'true'); }
        $$('video', el).forEach(function (v) { if (slides[i].contains(v)) { try { v.play(); } catch (e) {} } else { v.pause(); } });
      }
      function play() { stop(); if (auto && !reduceMotion) timer = setInterval(function () { if (!document.hidden) go(i + 1); }, speed); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
      var p = $('[data-st-prev]', el), nx = $('[data-st-next]', el);
      if (p) p.addEventListener('click', function () { go(i - 1); play(); });
      if (nx) nx.addEventListener('click', function () { go(i + 1); play(); });
      el.addEventListener('mouseenter', stop);
      el.addEventListener('mouseleave', play);
      el.addEventListener('focusin', stop);
      var x0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
        x0 = null; play();
      });
      play();
    });
  }

  /* ---------------- cart ---------------- */
  function cartSections() {
    var ids = ['aldo-cart-drawer'];
    $$('[data-st-cart-section]').forEach(function (s) { ids.push(s.getAttribute('data-st-cart-section')); });
    return ids;
  }
  function cartState(root) {
    var prog = root && $('[data-st-progress]', root);
    return {
      reached: prog ? parseInt(prog.getAttribute('data-reached'), 10) || 0 : 0,
      tiers: prog ? parseInt(prog.getAttribute('data-tiers'), 10) || 0 : 0,
      keys: root ? $$('[data-key]', root).map(function (l) { return l.getAttribute('data-key'); }) : []
    };
  }
  function afterRender(root, before) {
    if (!root) return;
    var now = cartState(root);
    // fade in lines that were just added
    $$('[data-key]', root).forEach(function (l) {
      if (before.keys.indexOf(l.getAttribute('data-key')) === -1 && before.keys.length + 1 > 1) l.classList.add('is-new');
    });
    // animate the progress bar from its old width to the new one
    var bar = $('[data-st-progress] .st-tiers__fill', root);
    if (bar && before.width != null) {
      var to = bar.style.getPropertyValue('--p');
      if (to !== before.width) {
        // start from the old width, force a layout, then let the CSS transition run to the new width
        bar.style.transition = 'none';
        bar.style.setProperty('--p', before.width);
        void bar.offsetWidth;
        bar.style.transition = '';
        bar.style.setProperty('--p', to);
      }
    }
    if (now.tiers > 0 && now.reached > before.reached && now.reached >= now.tiers) S.confetti(root);
    initRails(root);
    loadPairs(root);
    var orphan = $('[data-st-remove-protection]', root);
    if (orphan) S.cart.change(parseInt(orphan.getAttribute('data-line'), 10), 0, null);
  }
  // Horizon's header owns the bag icon; keep its count bubble in step with the Strade bag
  function syncHorizonBubble(count) {
    $$('cart-icon').forEach(function (icon) {
      try {
        if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(count);
        else { var n = icon.querySelector('[ref="cartBubbleCount"]'); if (n) n.textContent = count < 100 ? String(count) : ''; }
        icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      } catch (e) {}
    });
  }
  // Horizon's bag icon is a link to /cart (cart type "page"); open the Strade drawer instead
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.header-actions__action.action__cart, a.action__cart, [data-testid="cart-drawer-trigger"]');
    if (!link || C.cartType === 'page') return;
    var drawer = document.getElementById('StCartDrawer');
    if (!drawer || window.location.pathname === (R.cart || '/cart')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    e.stopPropagation();
    S.open(drawer, link);
  }, true);

  // Keep keyboard focus on the same control (e.g. a quantity button) after the bag re-renders
  function focusKey(root) {
    var a = document.activeElement;
    if (!a || !root.contains(a)) return null;
    var line = a.closest('[data-key]');
    return { key: line ? line.getAttribute('data-key') : null, sel: a.hasAttribute('data-st-line-qty') ? (a.textContent.trim() === '+' ? 'plus' : 'minus') : (a.matches('input') ? 'input' : null) };
  }
  function restoreFocus(root, f) {
    if (!f || !f.key) return;
    var line = $('[data-key="' + f.key + '"]', root);
    if (!line) { var c = $('[data-st-close]', root) || $('.st-close-round', root); if (c) c.focus({ preventScroll: true }); return; }
    var btns = $$('[data-st-line-qty]', $('.st-qty', line) || line);
    var el = f.sel === 'plus' ? btns[1] : f.sel === 'minus' ? btns[0] : $('input', line);
    if (el && !el.disabled) el.focus({ preventScroll: true });
  }
  function applySections(sections) {
    if (!sections) return;
    var drawerHTML = sections['aldo-cart-drawer'];
    if (drawerHTML) {
      var doc = parseHTML(drawerHTML);
      var fresh = $('[data-st-cart-inner]', doc);
      var cur = $('[data-st-cart-inner]');
      if (fresh && cur) {
        var before = cartState(cur);
        var oldBar = $('[data-st-progress] .st-tiers__fill', cur);
        before.width = oldBar ? oldBar.style.getPropertyValue('--p') : null;
        var scrollPos = ($('.st-drawer__body', cur) || {}).scrollTop || 0;
        var focus = focusKey(cur);
        var openExtras = $$('details.st-extra[open]', cur).map(function (d) { return $('summary span', d).textContent; });
        cur.innerHTML = fresh.innerHTML;
        var body = $('.st-drawer__body', cur); if (body) body.scrollTop = scrollPos;
        $$('details.st-extra', cur).forEach(function (d) { if (openExtras.indexOf($('summary span', d).textContent) > -1) d.open = true; });
        afterRender(cur, before);
        restoreFocus(cur, focus);
      }
      var count = fresh ? fresh.getAttribute('data-count') : null;
      if (count !== null) {
        $$('[data-st-cart-count]').forEach(function (b) {
          b.textContent = count;
          b.setAttribute('data-count', count);
          b.classList.add('is-bump');
          setTimeout(function () { b.classList.remove('is-bump'); }, 250);
        });
        $$('[data-st-cart-label]').forEach(function (l) { l.setAttribute('aria-label', l.getAttribute('data-label-base') + ' (' + count + ')'); });
        syncHorizonBubble(parseInt(count, 10) || 0);
      }
    }
    $$('[data-st-cart-section]').forEach(function (sec) {
      var id = sec.getAttribute('data-st-cart-section');
      if (!sections[id]) return;
      var doc = parseHTML(sections[id]);
      var fresh = $('[data-st-cart-section]', doc);
      if (!fresh) return;
      var before = cartState(sec);
      var oldBar = $('[data-st-progress] .st-tiers__fill', sec);
      before.width = oldBar ? oldBar.style.getPropertyValue('--p') : null;
      var focus = focusKey(sec);
      sec.innerHTML = fresh.innerHTML;
      afterRender(sec, before);
      restoreFocus(sec, focus);
    });
  }
  function jsonFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: body instanceof FormData ? { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } : { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body instanceof FormData ? body : JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || T.error);
        return data;
      });
    });
  }
  function flashAdded(btn) {
    if (!btn || !document.contains(btn)) return;
    var label = $('span', btn) || btn;
    var old = label.innerHTML;
    btn.classList.add('is-added');
    label.textContent = T.addedShort || 'Added';
    setTimeout(function () { if (!document.contains(btn)) return; btn.classList.remove('is-added'); label.innerHTML = old; }, 1400);
  }
  S.cart = {
    add: function (payload, btn, msgEl) {
      // ignore repeat taps while this button's add is still on its way
      if (btn && btn.classList.contains('is-loading')) return Promise.resolve();
      var body;
      if (payload instanceof FormData) { body = payload; body.append('sections', cartSections().join(',')); body.append('sections_url', window.location.pathname); }
      else { body = { items: [payload], sections: cartSections(), sections_url: window.location.pathname }; }
      if (btn) btn.classList.add('is-loading');
      if (msgEl) msgEl.textContent = '';
      return jsonFetch((R.cartAdd || '/cart/add') + '.js', body).then(function (data) {
        if (C.cartType === 'page' && !$('[data-st-cart-section]') && !(btn && btn.closest('#StCartDrawer'))) { window.location.href = R.cart || '/cart'; return; }
        if (btn) btn.classList.remove('is-loading');
        flashAdded(btn);
        applySections(data.sections);
        var drawer = $('#StCartDrawer');
        var inCart = btn && (btn.closest('#StCartDrawer') || btn.closest('[data-st-cart-section]'));
        if (drawer && !inCart && !$('[data-st-cart-section]')) S.open(drawer, btn);
        else if (!drawer) S.toast(T.added);
        document.dispatchEvent(new CustomEvent('st:cart:added', { detail: data }));
      }).catch(function (err) {
        if (msgEl) msgEl.textContent = err.message; else S.toast(err.message);
      }).finally(function () { if (btn) btn.classList.remove('is-loading'); });
    },
    // line: a line number, or a line item key (string), which stays right when lines move
    change: function (line, quantity, lineEl) {
      if (lineEl) lineEl.classList.add('is-loading');
      var body = { quantity: quantity, sections: cartSections(), sections_url: window.location.pathname };
      if (typeof line === 'string') body.id = line; else body.line = line;
      return jsonFetch((R.cartChange || '/cart/change') + '.js', body)
        .then(function (data) { applySections(data.sections); syncQueuedQty(); return true; })
        .catch(function (err) {
          S.toast(err.message);
          if (lineEl) { lineEl.classList.remove('is-loading', 'is-leaving'); lineEl.style.height = ''; }
          return false;
        });
    },
    note: debounce(function (note) {
      jsonFetch((R.cartUpdate || '/cart/update') + '.js', { note: note }).catch(function () {});
    }, 400)
  };

  // "Pairs well with": product recommendations for the first item in the bag
  var pairsCache = {};
  function loadPairs(root) {
    $$('[data-st-pairs-recs]', root || document).forEach(function (box) {
      var pid = box.getAttribute('data-product-id');
      var url = box.getAttribute('data-url');
      if (!pid || !url || box.getAttribute('data-loaded') === pid) return;
      box.setAttribute('data-loaded', pid);
      var fill = function (html) {
        var fresh = $('[data-st-pairs-items]', parseHTML(html));
        var track = $('[data-st-track]', box);
        if (fresh && fresh.children.length && track) {
          track.innerHTML = fresh.innerHTML;
          box.hidden = false;
          track.scrollLeft = 0;
          initRails(box);
          track.dispatchEvent(new Event('scroll'));
        } else if (!track || !track.children.length) { box.hidden = true; }
      };
      if (pairsCache[pid]) { fill(pairsCache[pid]); return; }
      fetch(url).then(function (r) { return r.text(); }).then(function (html) { pairsCache[pid] = html; fill(html); }).catch(function () {});
    });
  }
  S.loadPairs = loadPairs;

  // +/- taps add up on screen; one request goes out when the shopper pauses. The buttons carry
  // the rendered qty +/- 1, so the step is taken from them and added to the queued amount.
  var qtyQueue = {};
  function queueQty(line, target) {
    var key = line.getAttribute('data-key');
    if (!key) { S.cart.change(parseInt(line.getAttribute('data-line'), 10), target, line); return; }
    var shown = parseInt(line.getAttribute('data-qty'), 10) || 0;
    var q = qtyQueue[key] || (qtyQueue[key] = { qty: shown });
    q.qty = Math.max(0, q.qty + (target - shown));
    syncQueuedQty();
    clearTimeout(q.timer);
    q.timer = setTimeout(function () {
      var want = q.qty;
      S.cart.change(key, want, null).then(function () {
        if (qtyQueue[key] === q && q.qty === want) delete qtyQueue[key];
        syncQueuedQty();
      });
    }, 350);
  }
  function syncQueuedQty() {
    Object.keys(qtyQueue).forEach(function (key) {
      $$('[data-key="' + key + '"] [data-st-line-input]').forEach(function (input) { input.value = qtyQueue[key].qty; });
    });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-st-line-qty]');
    if (q) {
      e.preventDefault();
      var line = q.closest('[data-line]');
      var n = parseInt(q.getAttribute('data-st-line-qty'), 10);
      if (n === 0) {
        var undo = { id: parseInt(line.getAttribute('data-variant-id'), 10), quantity: parseInt(line.getAttribute('data-qty'), 10) || 1, title: line.getAttribute('data-title') || '' };
        var lineNo = parseInt(line.getAttribute('data-line'), 10);
        var removeNow = function () {
          S.cart.change(lineNo, 0, line).then(function (ok) {
            if (!ok || !undo.id) return;
            S.toast((undo.title ? undo.title + ' removed' : 'Item removed'), { label: 'Undo', onClick: function () { S.cart.add({ id: undo.id, quantity: undo.quantity }, null); } });
          });
        };
        if (reduceMotion) { removeNow(); return; }
        // collapse the line first so the removal feels smooth
        line.style.height = line.offsetHeight + 'px';
        line.classList.add('is-leaving');
        void line.offsetHeight;
        line.style.height = '0px';
        setTimeout(removeNow, 180);
      } else {
        queueQty(line, n);
      }
      return;
    }
    var pairAdd = e.target.closest('[data-st-pair-add]');
    if (pairAdd) {
      e.preventDefault();
      var card = pairAdd.closest('.st-pair');
      var sel = card && $('select[data-st-pair-select]', card);
      var vid = sel ? sel.value : pairAdd.getAttribute('data-st-pair-add');
      if (!vid) { if (sel) sel.focus(); return; }
      S.cart.add({ id: parseInt(vid, 10), quantity: 1 }, pairAdd);
      return;
    }
    var add = e.target.closest('[data-st-add-variant]');
    if (add) {
      e.preventDefault();
      S.cart.add({ id: parseInt(add.getAttribute('data-st-add-variant'), 10), quantity: 1 }, add);
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-st-line-input]');
    if (input) {
      var line = input.closest('[data-line]');
      var v = Math.max(0, parseInt(input.value, 10) || 0);
      S.cart.change(parseInt(line.getAttribute('data-line'), 10), v, line);
    }
    var pairSel = e.target.closest('select[data-st-pair-select]');
    if (pairSel) {
      var opt = pairSel.options[pairSel.selectedIndex];
      var now = pairSel.closest('.st-pair').querySelector('[data-st-pair-price] .st-price__now');
      if (now && opt && opt.getAttribute('data-price')) now.textContent = opt.getAttribute('data-price');
    }
    var prot = e.target.closest('[data-st-protection]');
    if (prot) {
      prot.disabled = true;
      var wrap = prot.closest('.st-protect'); if (wrap) wrap.classList.add('is-loading');
      if (prot.checked) S.cart.add({ id: parseInt(prot.getAttribute('data-variant'), 10), quantity: 1 }, null);
      else S.cart.change(parseInt(prot.getAttribute('data-line'), 10), 0, null);
    }
    if (e.target.matches('[data-st-cart-note]')) S.cart.note(e.target.value);
    if (e.target.matches('[data-st-localize]')) e.target.form.submit();
  });
  document.addEventListener('input', function (e) { if (e.target.matches('[data-st-cart-note]')) S.cart.note(e.target.value); });
  // Discount codes without leaving the page (Cart Ajax API: /cart/update.js { discount })
  function currentCodes(root) {
    return $$('[data-st-remove-code]', root || document).map(function (b) { return b.getAttribute('data-st-remove-code'); });
  }
  function setCodes(codes, btn, msg, tried) {
    if (btn) btn.classList.add('is-loading');
    return jsonFetch((R.cartUpdate || '/cart/update') + '.js', { discount: codes.join(','), sections: cartSections(), sections_url: window.location.pathname })
      .then(function (data) {
        applySections(data.sections);
        if (tried) {
          var hit = (data.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === tried.toLowerCase(); })[0];
          var note = '"' + tried + '" can’t be used with this cart.';
          if (hit && hit.applicable) { S.toast('Code ' + hit.code + ' applied'); return; }
          // Shopify keeps rejected codes on the cart; take it off again so only working codes remain
          var keep = (data.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
          return jsonFetch((R.cartUpdate || '/cart/update') + '.js', { discount: keep.join(','), sections: cartSections(), sections_url: window.location.pathname })
            .then(function (d2) { applySections(d2.sections); var m = $('[data-st-code-msg]'); if (m) m.textContent = note; })
            .catch(function () { var m = $('[data-st-code-msg]'); if (m) m.textContent = note; });
        }
      })
      .catch(function (err) { if (msg) msg.textContent = err.message; })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-st-remove-code]');
    if (rm) {
      e.preventDefault();
      var code = rm.getAttribute('data-st-remove-code');
      setCodes(currentCodes().filter(function (c) { return c !== code; }), rm, null, null);
    }
  });
  document.addEventListener('submit', function (e) {
    var ajax = e.target.closest('[data-st-ajax-discount]');
    if (ajax) {
      e.preventDefault();
      var input = $('input', ajax);
      var msg = ajax.parentNode.querySelector('[data-st-code-msg]');
      var code = (input.value || '').trim();
      if (!code) { if (msg) msg.textContent = 'Enter a promo code.'; input.focus(); return; }
      var codes = currentCodes(ajax.closest('[data-st-cart-inner], [data-st-cart-section]'));
      if (codes.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) > -1) { if (msg) msg.textContent = 'That code is already applied.'; return; }
      setCodes(codes.concat([code]), $('button', ajax), msg, code);
      return;
    }
    var co = e.target.closest('[data-st-checkout]');
    if (co) {
      var b = $('button[name="checkout"]', co);
      if (b) { if (b.classList.contains('is-loading')) { e.preventDefault(); return; } b.classList.add('is-loading'); }
      return;
    }
    var f = e.target.closest('[data-st-discount]');
    if (f) {
      e.preventDefault();
      var code = (f.querySelector('input').value || '').trim();
      if (!code) { var m = f.parentNode.querySelector('[data-st-discount-msg]'); if (m) m.textContent = 'Enter a promo code.'; return; }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(R.cart || '/cart');
    }
  });
  document.addEventListener('st:open', function (e) { if (e.target.id === 'StCartDrawer') loadPairs(e.target); });

  /* ---------------- confetti ---------------- */
  S.confetti = function () {
    if (reduceMotion || C.confetti === false) return;
    var canvas = document.createElement('canvas');
    canvas.className = 'st-confetti';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = canvas.width = window.innerWidth * dpr;
    var h = canvas.height = window.innerHeight * dpr;
    var colors = (C.confettiColors && C.confettiColors.length) ? C.confettiColors : ['#111111', '#b3001b', '#d4c3b0', '#8a6f58', '#f2efe9'];
    var drawer = document.getElementById('StCartDrawer');
    var rect = drawer && drawer.classList.contains('is-open') ? drawer.getBoundingClientRect() : { left: 0, width: window.innerWidth };
    var pieces = [];
    for (var i = 0; i < 140; i++) {
      pieces.push({
        x: (rect.left + Math.random() * rect.width) * dpr,
        y: (-20 - Math.random() * window.innerHeight * 0.5) * dpr,
        vx: (Math.random() - 0.5) * 2.2 * dpr,
        vy: (2.2 + Math.random() * 3.2) * dpr,
        r: (4 + Math.random() * 5) * dpr,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.25,
        c: colors[i % colors.length],
        shape: i % 3
      });
    }
    var start = performance.now();
    function frame(t) {
      var elapsed = t - start;
      ctx.clearRect(0, 0, w, h);
      var alive = false;
      pieces.forEach(function (p) {
        p.x += p.vx; p.y += p.vy; p.vy += 0.035 * dpr; p.rot += p.vr; p.vx *= 0.995;
        if (p.y < h + 20) alive = true;
        ctx.save();
        ctx.globalAlpha = elapsed > 2200 ? Math.max(0, 1 - (elapsed - 2200) / 600) : 1;
        ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.fillStyle = p.c;
        if (p.shape === 0) ctx.fillRect(-p.r / 2, -p.r / 4, p.r, p.r / 2);
        else if (p.shape === 1) { ctx.beginPath(); ctx.arc(0, 0, p.r / 3, 0, Math.PI * 2); ctx.fill(); }
        else ctx.fillRect(-p.r / 4, -p.r / 2, p.r / 2, p.r);
        ctx.restore();
      });
      if (alive && elapsed < 2800) requestAnimationFrame(frame); else canvas.remove();
    }
    requestAnimationFrame(frame);
  };

  /* ---------------- product cards: swatches, quick add, view transition ---------------- */
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('[data-swatch-img]');
    if (!sw) return;
    swapCardImage(sw);
  });
  document.addEventListener('focusin', function (e) { var sw = e.target.closest('[data-swatch-img]'); if (sw) swapCardImage(sw); });
  function swapCardImage(sw) {
    var card = sw.closest('.st-card');
    var img = card && $('.st-card__img1', card);
    var src = sw.getAttribute('data-swatch-img');
    if (!img || !src) return;
    if (!img.dataset.orig) { img.dataset.orig = img.currentSrc || img.src; img.dataset.origSet = img.getAttribute('srcset') || ''; }
    img.removeAttribute('srcset');
    img.src = src;
    $$('.st-swatch-dot', card).forEach(function (d) { d.classList.toggle('is-on', d === sw); });
    var link = sw.getAttribute('data-swatch-url');
    if (link) $$('a.st-card__title, a.st-card__media', card).forEach(function (a) { a.href = link; });
  }
  document.addEventListener('click', function (e) {
    var openQ = e.target.closest('[data-qa-open]');
    if (openQ) {
      e.preventDefault();
      $$('.st-qa.is-open').forEach(function (q) { q.classList.remove('is-open'); });
      var qa = openQ.closest('.st-qa');
      qa.classList.add('is-open');
      var first = $('.st-qa__size:not([disabled])', qa); if (first) first.focus({ preventScroll: true });
      return;
    }
    var closeQ = e.target.closest('[data-qa-close]');
    if (closeQ) { e.preventDefault(); closeQ.closest('.st-qa').classList.remove('is-open'); return; }
    if (!e.target.closest('.st-qa')) $$('.st-qa.is-open').forEach(function (q) { q.classList.remove('is-open'); });

    // name the clicked card's image so it morphs into the product page
    var cardLink = e.target.closest('.st-card a.st-card__title, .st-card a.st-card__media');
    if (cardLink && 'startViewTransition' in document) {
      $$('[style*="view-transition-name"]').forEach(function (n) { n.style.viewTransitionName = ''; });
      var img = $('.st-card__img1', cardLink.closest('.st-card'));
      if (img) img.style.viewTransitionName = 'st-media';
    }
  });
  window.addEventListener('pageshow', function () { $$('.st-card__img1').forEach(function (n) { n.style.viewTransitionName = ''; }); });

  /* ---------------- product page ---------------- */
  function initProducts(root) {
    $$('[data-st-product]', root).forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var dataEl = $('[data-st-variants]', el);
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var invEl = $('[data-st-inventory]', el);
      var inventory = invEl ? JSON.parse(invEl.textContent) : {};
      var form = $('[data-st-form]', el);
      var idInput = form ? $('input[name="id"]', form) : null;
      var btn = form ? $('[data-st-submit]', form) : null;
      var msg = $('[data-st-msg]', el);
      var priceEls = $$('[data-st-price]', el);
      var optionCount = variants.length ? variants[0].options.length : 0;
      var picker = $('[data-st-picker]', el);
      var sizeIndex = picker ? parseInt(picker.getAttribute('data-size-index'), 10) : -1;
      var requireSize = picker && picker.getAttribute('data-require-size') === 'true' && sizeIndex > -1;
      var lowStock = parseInt(el.getAttribute('data-low-stock'), 10) || 0;
      var gallery = $('[data-st-gallery]', el);
      var sticky = $('[data-st-sticky]', el);
      var selected = [];
      var current = variants.filter(function (v) { return String(v.id) === (idInput ? idInput.value : ''); })[0] || variants[0];

      function readSelected() {
        selected = [];
        for (var i = 0; i < optionCount; i++) {
          var checked = $('input[data-opt="' + i + '"]:checked', el);
          var sel = $('select[data-opt="' + i + '"]', el);
          selected.push(checked ? checked.value : (sel ? sel.value : null));
        }
      }
      function match(vals) {
        return variants.filter(function (v) { return v.options.every(function (o, i) { return vals[i] === null || vals[i] === undefined || o === vals[i]; }); });
      }
      function markAvailability() {
        for (var i = 0; i < optionCount; i++) {
          $$('[data-opt="' + i + '"]', el).forEach(function (input) {
            var vals = selected.slice();
            var opts = input.tagName === 'SELECT' ? $$('option', input) : [input];
            opts.forEach(function (o) {
              vals[i] = o.value;
              var avail = match(vals).some(function (v) { return v.available; });
              var wrap = o.tagName === 'OPTION' ? null : o.closest('.st-optbtn, .st-optsw');
              if (wrap) wrap.classList.toggle('is-oos', !avail);
              if (o.tagName === 'OPTION') o.textContent = o.value + (avail ? '' : ' — ' + T.soldOut);
            });
          });
        }
      }
      function renderPrice(v) {
        if (!v) return;
        var html = '<span class="st-price__now">' + S.money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<span class="st-price__was">' + S.money(v.compare_at_price) + '</span>';
          var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
          if (el.getAttribute('data-show-save') === 'true') html += '<span class="st-save">-' + pct + '%</span>';
        }
        priceEls.forEach(function (p) {
          p.innerHTML = html;
          p.classList.toggle('st-price--sale', !!(v.compare_at_price && v.compare_at_price > v.price));
        });
      }
      function renderInventory(v) {
        var box = $('[data-st-inv]', el);
        if (!box || !v) return;
        var q = inventory[v.id];
        var text = '';
        box.classList.remove('is-low', 'is-out');
        if (!v.available) { text = T.soldOut; box.classList.add('is-out'); }
        else if (typeof q === 'number' && q > 0 && lowStock && q <= lowStock) { text = (box.getAttribute('data-low') || 'Only [count] left').replace('[count]', q); box.classList.add('is-low'); }
        else { text = box.getAttribute('data-in') || 'In stock'; }
        $('span', box).textContent = text;
      }
      function syncSticky(needsSize, found) {
        var sb = $('[data-st-sticky-btn]', sticky);
        var optEl = $('[data-st-sticky-opt]', sticky);
        if (sb) {
          var lab = $('span', sb) || sb;
          if (needsSize) { sb.disabled = false; lab.textContent = T.chooseSize || 'Select a size'; }
          else { sb.disabled = btn.disabled; lab.textContent = ($('span', btn) || btn).textContent; }
          sb.classList.toggle('is-choose', !!needsSize);
        }
        var thumb = $('.st-stickybuy__img img', sticky);
        var media = found && found.featured_media && (found.featured_media.preview_image || found.featured_media);
        if (thumb && media && media.src) {
          thumb.removeAttribute('srcset');
          thumb.src = media.src + (media.src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        }
        if (optEl) {
          var parts = [];
          selected.forEach(function (v, i) { if (v && optionCount > 1) parts.push(i === sizeIndex ? 'Size ' + v : v); });
          if (!parts.length && found && optionCount === 1 && sizeIndex === 0) parts.push('Size ' + found.options[0]);
          optEl.textContent = parts.join(' · ');
        }
      }
      function scrollToMedia(v, instant) {
        if (!gallery || !v || !v.featured_media) return;
        var item = $('[data-media-id="' + v.featured_media.id + '"]', gallery);
        if (!item) return;
        var track = $('.st-gal__track', gallery);
        var isSlider = getComputedStyle(track).display === 'grid' && track.scrollWidth > track.clientWidth + 4;
        if (isSlider) track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: reduceMotion || instant ? 'auto' : 'smooth' });
        else if (gallery.getAttribute('data-move-first') === 'true' && item !== track.firstElementChild) {
          if (item.animate && !instant) item.animate([{ opacity: 0.2 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
          track.insertBefore(item, track.firstElementChild);
          syncThumbs();
        }
      }
      function update(fromUser) {
        readSelected();
        var vals = selected.slice();
        var needsSize = requireSize && !vals[sizeIndex];
        if (needsSize) vals[sizeIndex] = null;
        var found = needsSize ? null : match(vals)[0];
        markAvailability();
        $$('[data-opt-label]', el).forEach(function (lab) {
          var i = parseInt(lab.getAttribute('data-opt-label'), 10);
          lab.textContent = selected[i] || lab.getAttribute('data-empty') || '';
        });
        if (found) {
          current = found;
          if (idInput) idInput.value = found.id;
          renderPrice(found);
          renderInventory(found);
          if (fromUser) scrollToMedia(found);
          var sku = $('[data-st-sku]', el); if (sku) sku.textContent = found.sku || '';
          if (fromUser && el.getAttribute('data-update-url') === 'true') {
            var url = new URL(window.location.href); url.searchParams.set('variant', found.id);
            history.replaceState(history.state, '', url.toString());
          }
        } else if (!needsSize) {
          current = null;
        }
        if (btn) {
          var label = $('span', btn) || btn;
          if (needsSize) { btn.disabled = false; label.textContent = btn.getAttribute('data-label-add') || T.add; }
          else if (!found) { btn.disabled = true; label.textContent = T.unavailable; }
          else if (!found.available) { btn.disabled = true; label.textContent = T.soldOut; }
          else { btn.disabled = false; label.textContent = btn.getAttribute('data-label-add') || T.add; }
          if (sticky) syncSticky(needsSize, found);
          var bn = $('[data-st-buy-now]', el);
          if (bn) bn.disabled = !needsSize && btn.disabled;
        }
        if (msg && fromUser) msg.textContent = '';
        var dyn = $('.shopify-payment-button', el);
        if (dyn) dyn.style.display = found && found.available ? '' : 'none';
      }
      el.addEventListener('change', function (e) {
        if (e.target.matches('[data-opt]')) update(true);
      });
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        readSelected();
        if (requireSize && !selected[sizeIndex]) {
          if (msg) msg.textContent = T.chooseSize;
          var opt = $('[data-opt="' + sizeIndex + '"]', el);
          if (opt) { (opt.closest('fieldset') || opt).scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' }); }
          return;
        }
        if (!current || !current.available) return;
        S.cart.add(new FormData(form), btn, msg);
      });

      // shared check for the extra buttons: a size must be chosen first
      function sizeReady() {
        readSelected();
        if (requireSize && !selected[sizeIndex]) {
          if (msg) msg.textContent = T.chooseSize;
          var opt = $('[data-opt="' + sizeIndex + '"]', el);
          var box = opt ? (opt.closest('fieldset') || opt) : null;
          if (box) {
            box.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
            box.classList.remove('is-attn'); void box.offsetWidth; box.classList.add('is-attn');
          }
          return false;
        }
        return !!(current && current.available);
      }
      function chosenQty() {
        var q = form ? $('input[name="quantity"]', form) || $('input[name="quantity"]', el) : null;
        return Math.max(1, parseInt(q && q.value, 10) || 1);
      }
      // Buy it now: a cart permalink goes straight to checkout with only this item
      var buyNow = $('[data-st-buy-now]', el);
      if (buyNow) buyNow.addEventListener('click', function () {
        if (!sizeReady()) return;
        buyNow.classList.add('is-loading');
        window.location.href = (R.root || '/').replace(/\/?$/, '/') + 'cart/' + current.id + ':' + chosenQty();
      });
      // size guide: highlight the size the shopper has picked
      var sizeGuide = $('[data-st-size-guide]', el);
      if (sizeGuide) sizeGuide.addEventListener('st:open', function () {
        readSelected();
        var picked = sizeIndex > -1 ? selected[sizeIndex] : null;
        $$('tr[data-size]', sizeGuide).forEach(function (tr) { tr.classList.toggle('is-on', !!picked && tr.getAttribute('data-size') === String(picked)); });
      });
      toBody(sizeGuide);
      // Order on WhatsApp: opens a chat with the chosen size, quantity and price filled in
      var wa = $('[data-st-wa]', el);
      if (wa) wa.addEventListener('click', function (e) {
        e.preventDefault();
        if (!sizeReady()) return;
        var qty = chosenQty();
        var link = (wa.getAttribute('data-url') || window.location.origin + window.location.pathname) + '?variant=' + current.id;
        var text = (wa.getAttribute('data-message') || '[product]\n[variant]\nQty: [qty]\n[url]')
          .replace(/\[product\]/g, wa.getAttribute('data-title') || document.title)
          .replace(/\[variant\]/g, current.title || '')
          .replace(/\[qty\]/g, qty)
          .replace(/\[price\]/g, S.money(current.price * qty))
          .replace(/\[url\]/g, link);
        window.open('https://wa.me/' + wa.getAttribute('data-number') + '?text=' + encodeURIComponent(text), '_blank', 'noopener');
      });
      $$('[data-qty-step]', el).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = $('input[name="quantity"]', b.parentNode);
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
          input.value = v;
        });
      });

      // gallery dots, thumbs, zoom
      function syncThumbs() {}
      if (gallery) {
        var track = $('.st-gal__track', gallery);
        var dots = $$('.st-gal-dots i', el);
        var thumbs = $$('[data-thumb]', el);
        var counter = $('[data-st-gal-index]', el);
        var bar = $('[data-st-gal-bar]', el);
        track.addEventListener('scroll', debounce(function () {
          var items = $$('.st-gal__item', track);
          var idx = 0, best = Infinity;
          items.forEach(function (it, n) { var d = Math.abs(it.offsetLeft - track.offsetLeft - track.scrollLeft); if (d < best) { best = d; idx = n; } });
          dots.forEach(function (d, n) { d.classList.toggle('is-on', n === idx); });
          thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === idx); });
          if (counter) counter.textContent = idx + 1;
          if (bar) bar.style.setProperty('--i', idx);
          var activeThumb = thumbs[idx];
          if (activeThumb && activeThumb.parentNode.scrollWidth > activeThumb.parentNode.clientWidth) {
            activeThumb.parentNode.scrollTo({ left: activeThumb.offsetLeft - activeThumb.parentNode.offsetLeft - 24, behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        }, 60), { passive: true });
        thumbs.forEach(function (t, n) {
          t.addEventListener('click', function () {
            var it = $$('.st-gal__item', track)[n];
            if (it) track.scrollTo({ left: it.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
          });
        });
        var zoom = $('[data-st-zoom]', el);
        if (zoom) {
          gallery.addEventListener('click', function (e) {
            var z = e.target.closest('[data-zoom-index]');
            if (!z) return;
            S.open(zoom, z);
            var slide = $$('.st-zoom__slide', zoom)[parseInt(z.getAttribute('data-zoom-index'), 10)];
            if (slide) requestAnimationFrame(function () { slide.parentNode.scrollLeft = slide.offsetLeft; });
          });
          zoom.addEventListener('click', function (e) {
            var s = e.target.closest('.st-zoom__slide');
            if (s && e.target.tagName === 'IMG') s.classList.toggle('is-zoomed');
          });
          zoom.addEventListener('st:close', function () { $$('.st-zoom__slide', zoom).forEach(function (s) { s.classList.remove('is-zoomed'); }); });
          toBody(zoom);
        }
      }
      if (sticky && btn && 'IntersectionObserver' in window) {
        // show once the real button has scrolled above the screen; hide again near the footer
        var past = false, nearEnd = false;
        var showSticky = function () { sticky.classList.toggle('is-on', past && !nearEnd); };
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          past = !e.isIntersecting && e.boundingClientRect.top < 0;
          showSticky();
        }).observe(btn);
        var foot = $('footer') || $('[id$="footer_main"]');
        // only step aside once the footer fills a good part of the screen
        if (foot) new IntersectionObserver(function (entries) { nearEnd = entries[0].isIntersecting; showSticky(); }, { rootMargin: '0px 0px -40% 0px' }).observe(foot);
        var sb = $('[data-st-sticky-btn]', sticky);
        if (sb) sb.addEventListener('click', function () {
          readSelected();
          if (requireSize && !selected[sizeIndex]) {
            var opt = $('[data-opt="' + sizeIndex + '"]', el);
            var box = opt ? (opt.closest('fieldset') || opt) : null;
            if (box) {
              box.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
              box.classList.remove('is-attn'); void box.offsetWidth; box.classList.add('is-attn');
            }
            if (msg) msg.textContent = T.chooseSize;
            return;
          }
          sb.classList.add('is-loading');
          if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
          setTimeout(function () { sb.classList.remove('is-loading'); }, 1200);
        });
      }
      $$('[data-st-copy]', el).forEach(function (b) {
        b.addEventListener('click', function () {
          var url = b.getAttribute('data-st-copy');
          if (navigator.share) { navigator.share({ url: url, title: document.title }).catch(function () {}); return; }
          if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { S.toast('Link copied'); }).catch(function () { S.toast(url); });
        });
      });

      // remember for "recently viewed"
      var rv = $('[data-st-rv]', el);
      if (rv) {
        try {
          var item = JSON.parse(rv.textContent);
          var list = JSON.parse(localStorage.getItem('st-recent') || '[]').filter(function (x) { return x.handle !== item.handle; });
          list.unshift(item);
          localStorage.setItem('st-recent', JSON.stringify(list.slice(0, 12)));
        } catch (e) {}
      }
      update(false);
      // open on the selected colour's photo, not just the product's first image
      if (current && gallery && gallery.getAttribute('data-move-first') === 'true') scrollToMedia(current, true);
    });
  }

  /* ---------------- recommendations & recently viewed ---------------- */
  function initRecs(root) {
    $$('[data-st-recs-url]', root).forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      fetch(box.getAttribute('data-st-recs-url')).then(function (r) { return r.text(); }).then(function (html) {
        var fresh = $('[data-st-recs-url]', parseHTML(html));
        if (fresh && fresh.innerHTML.trim()) { box.innerHTML = fresh.innerHTML; initRails(box); }
        else { var sec = box.closest('.shopify-section'); if (sec) sec.style.display = 'none'; }
      }).catch(function () {});
    });
    $$('[data-st-recent]', root).forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var list = [];
      try { list = JSON.parse(localStorage.getItem('st-recent') || '[]'); } catch (e) {}
      var skip = box.getAttribute('data-exclude');
      var limit = parseInt(box.getAttribute('data-limit'), 10) || 8;
      list = list.filter(function (x) { return x.handle !== skip; }).slice(0, limit);
      var sec = box.closest('.shopify-section');
      if (!list.length) { if (sec && !(window.Shopify && window.Shopify.designMode)) sec.style.display = 'none'; return; }
      var track = $('[data-st-track]', box);
      track.innerHTML = list.map(function (p) {
        var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
        return '<li><div class="st-card"><a class="st-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
          (p.image ? '<img class="st-card__img1" src="' + esc(p.image) + '" alt="" loading="lazy" width="600" height="800">' : '') +
          '</a><div class="st-card__info"><a class="st-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          (p.type ? '<span class="st-card__sub">' + esc(p.type) + '</span>' : '') +
          '<div class="st-price">' + p.price + '</div></div></div></li>';
      }).join('');
      initRails(box);
    });
  }

  /* ---------------- collection & search filters ---------------- */
  function initFacets(root) {
    $$('[data-st-facets]', root).forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var sectionId = wrap.getAttribute('data-section-id');
      var busy = null;
      function render(url, push) {
        var results = $('[data-st-results]', wrap);
        if (results) results.classList.add('is-loading');
        var u = new URL(url, window.location.origin);
        u.searchParams.set('section_id', sectionId);
        if (busy) busy.abort();
        busy = 'AbortController' in window ? new AbortController() : null;
        fetch(u.toString(), busy ? { signal: busy.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
          var doc = parseHTML(html);
          ['[data-st-results]', '[data-st-active]', '[data-st-count]', '[data-st-more]'].forEach(function (sel) {
            var fresh = $(sel, doc), cur = $(sel, wrap);
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          });
          $$('[data-st-filter-body]', wrap).forEach(function (cur) {
            var key = cur.getAttribute('data-st-filter-body');
            var fresh = $('[data-st-filter-body="' + key + '"]', doc);
            if (!fresh) return;
            var openNames = $$('details[open]', cur).map(function (d) { return d.getAttribute('data-name'); });
            cur.innerHTML = fresh.innerHTML;
            $$('details', cur).forEach(function (d) { if (openNames.indexOf(d.getAttribute('data-name')) > -1) d.open = true; });
          });
          var cnt = $('[data-st-count]', wrap);
          $$('[data-st-apply]', wrap).forEach(function (b) { if (cnt) b.textContent = b.getAttribute('data-label').replace('[count]', cnt.getAttribute('data-n') || cnt.textContent.replace(/\D/g, '')); });
          if (push) {
            var clean = new URL(url, window.location.origin); clean.searchParams.delete('section_id');
            history.replaceState({}, '', clean.pathname + clean.search);
          }
          var r2 = $('[data-st-results]', wrap); if (r2) r2.classList.remove('is-loading');
          initMore(wrap);
        }).catch(function (e) { if (e && e.name === 'AbortError') return; window.location.href = url; });
      }
      function formUrl() {
        var forms = $$('form[data-st-filter-form]', wrap);
        var form = forms.filter(function (f) { return f.offsetParent !== null; })[0] || forms[0];
        var params = new URLSearchParams();
        if (form) new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
        var sort = $('[data-st-sort]', wrap); if (sort && sort.value) params.set('sort_by', sort.value);
        var q = wrap.getAttribute('data-q'); if (q !== null && !params.has('q')) params.set('q', q);
        if (wrap.getAttribute('data-type') && !params.has('type')) params.set('type', wrap.getAttribute('data-type'));
        return window.location.pathname + '?' + params.toString();
      }
      var go = debounce(function () { render(formUrl(), true); }, 280);
      wrap.addEventListener('change', function (e) {
        if (e.target.closest('form[data-st-filter-form]') || e.target.matches('[data-st-sort]')) {
          // keep the drawer and the sidebar in sync
          if (e.target.name && e.target.type === 'checkbox') $$('input[name="' + e.target.name + '"][value="' + CSS.escape(e.target.value) + '"]', wrap).forEach(function (i) { i.checked = e.target.checked; });
          go();
        }
      });
      wrap.addEventListener('submit', function (e) { if (e.target.matches('form[data-st-filter-form]')) { e.preventDefault(); render(formUrl(), true); S.close(); } });
      wrap.addEventListener('click', function (e) {
        var a = e.target.closest('[data-st-facet-link]');
        if (a) { e.preventDefault(); render(a.href, true); return; }
        var chip = e.target.closest('[data-st-chip]');
        if (chip && chip.getAttribute('href')) return; // real link to sub-collection
      });
      document.addEventListener('click', function (e) { var a = e.target.closest('[data-st-apply-close]'); if (a && wrap.contains(a)) { e.preventDefault(); S.close(); } });
      initMore(wrap);
      function initMore(scope) {
        var more = $('[data-st-loadmore]', scope);
        if (!more || more.dataset.ready) return;
        more.dataset.ready = '1';
        function load() {
          if (more.classList.contains('is-loading')) return;
          more.classList.add('is-loading');
          var u = new URL(more.getAttribute('href'), window.location.origin);
          u.searchParams.set('section_id', sectionId);
          fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
            var doc = parseHTML(html);
            var grid = $('[data-st-grid]', wrap), freshGrid = $('[data-st-grid]', doc);
            if (grid && freshGrid) Array.prototype.slice.call(freshGrid.children).forEach(function (li) {
              if (li.classList.contains('st-promo-tile')) return;
              li.style.opacity = '0';
              grid.appendChild(li);
              requestAnimationFrame(function () { li.style.transition = 'opacity var(--st-dur)'; li.style.opacity = '1'; });
            });
            var m = $('[data-st-more]', wrap), fm = $('[data-st-more]', doc);
            if (m && fm) m.innerHTML = fm.innerHTML;
            initMore(wrap);
          }).catch(function () { window.location.href = more.getAttribute('href'); });
        }
        more.addEventListener('click', function (e) { e.preventDefault(); load(); });
        if (more.getAttribute('data-auto') === 'true' && 'IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
          io.observe(more);
        }
      }
    });
  }

  /* ---------------- predictive search ---------------- */
  function initSearch(root) {
    $$('[data-st-search]', root).forEach(function (panel) {
      if (panel.dataset.ready) return;
      panel.dataset.ready = '1';
      var input = $('[data-st-search-input]', panel);
      var out = $('[data-st-predictive]', panel);
      if (!input || !out) return;
      var initial = out.innerHTML;
      var clearBtn = $('[data-st-search-clear]', panel);
      var form = input.form;
      var ctrl = null;
      var showInitial = function () { out.innerHTML = initial; renderRecent(); };
      var run = debounce(function () {
        var q = input.value.trim();
        if (clearBtn) clearBtn.hidden = !q;
        if (!q) { if (ctrl) ctrl.abort(); panel.classList.remove('st-sd__loading'); showInitial(); return; }
        if (!C.predictive) return;
        if (ctrl) ctrl.abort();
        ctrl = 'AbortController' in window ? new AbortController() : null;
        panel.classList.add('st-sd__loading');
        var url = (R.predictive || '/search/suggest') + '?q=' + encodeURIComponent(q) + '&section_id=aldo-predictive-search&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each&resources[options][prefix]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
          if (input.value.trim() !== q) return;
          var fresh = $('[data-st-predictive-results]', parseHTML(html));
          out.innerHTML = fresh ? fresh.innerHTML : '';
          panel.classList.remove('st-sd__loading');
        }).catch(function (err) {
          // a newer search aborted this one and owns the loading state; otherwise stop the spinner
          if (!err || err.name !== 'AbortError') panel.classList.remove('st-sd__loading');
        });
      }, 200);

      // recently searched, kept in this browser only
      function readRecent() { try { return JSON.parse(localStorage.getItem('st-searches') || '[]'); } catch (e) { return []; } }
      function remember(term) {
        term = (term || '').trim();
        if (!term) return;
        var list = readRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
        list.unshift(term);
        try { localStorage.setItem('st-searches', JSON.stringify(list.slice(0, 6))); } catch (e) {}
      }
      function renderRecent() {
        var list = $('[data-st-sd-recent]', panel);
        if (!list) return;
        var items = readRecent();
        var empty = $('[data-st-sd-recent-empty]', panel);
        list.innerHTML = '';
        items.forEach(function (t) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'st-sd__term'; b.setAttribute('data-st-term', t);
          b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 7v5l3 2"/><circle cx="12" cy="12" r="8.5"/></svg><span></span>';
          b.lastChild.textContent = t;
          li.appendChild(b); list.appendChild(li);
        });
        if (items.length) {
          var li2 = document.createElement('li');
          li2.innerHTML = '<button type="button" class="st-sd__clear-recent" data-st-sd-forget>Clear recent searches</button>';
          list.appendChild(li2);
        }
        if (empty) empty.hidden = items.length > 0;
      }
      renderRecent();

      input.addEventListener('input', run);
      if (form) form.addEventListener('submit', function (e) {
        if (!input.value.trim()) { e.preventDefault(); input.focus(); return; }
        remember(input.value);
      });
      if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; clearBtn.hidden = true; showInitial(); input.focus(); });
      panel.addEventListener('st:open', function () { if (!input.value.trim()) showInitial(); });
      panel.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-st-sd-tab]');
        if (tab) {
          var name = tab.getAttribute('data-st-sd-tab');
          $$('[data-st-sd-tab]', panel).forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
          $$('[data-st-sd-panel]', panel).forEach(function (p) { p.hidden = p.getAttribute('data-st-sd-panel') !== name; });
          return;
        }
        if (e.target.closest('[data-st-sd-forget]')) { try { localStorage.removeItem('st-searches'); } catch (err) {} renderRecent(); return; }
        var t = e.target.closest('[data-st-term]');
        if (t) { e.preventDefault(); input.value = t.getAttribute('data-st-term'); remember(input.value); input.focus(); run(); return; }
        var r = e.target.closest('[data-st-remember]');
        if (r) remember(r.getAttribute('data-st-remember'));
      });
    });
  }

  // Horizon's search icon (and the field added to its mobile menu) open the Strade search drawer
  function openSearch(trigger) {
    var d = document.getElementById('StSearchDrawer');
    if (!d) return false;
    var menu = document.querySelector('.menu-drawer-container[open], details.menu-drawer-container[open]');
    if (menu) {
      // Close Horizon's menu first. It releases its scroll lock and focus trap only when its
      // close animation ends, so search opens after that (once, with a fallback).
      var hd = menu.closest('header-drawer');
      if (hd && typeof hd.close === 'function') hd.close();
      else { var sum = menu.querySelector('summary'); if (sum) sum.click(); }
      var opened = false;
      var go = function () {
        if (opened) return;
        opened = true;
        S.open(d, document.querySelector('search-button button') || trigger);
      };
      var panel = menu.querySelector('.menu-drawer');
      var anims = panel && panel.getAnimations ? panel.getAnimations() : [];
      if (anims.length) Promise.all(anims.map(function (a) { return a.finished.catch(function () {}); })).then(function () { setTimeout(go, 20); });
      else setTimeout(go, 20);
      setTimeout(go, 700);
      return true;
    }
    S.open(d, trigger);
    return true;
  }
  S.openSearch = openSearch;
  // window + capture runs before Horizon's own document-level `on:click` handling
  window.addEventListener('click', function (e) {
    var b = e.target.closest('search-button button, .search-action button, [data-st-search-open]');
    if (!b || !document.getElementById('StSearchDrawer')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    openSearch(b);
  }, true);
  function addMenuSearch() {
    if (!document.getElementById('StSearchDrawer') || !C.menuSearch) return;
    $$('.menu-drawer__navigation').forEach(function (nav) {
      if ($('.st-menu-search', nav.parentNode)) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'st-menu-search';
      btn.setAttribute('data-st-search-open', '');
      btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg><span></span>';
      btn.lastChild.textContent = T.search || 'Search';
      nav.parentNode.insertBefore(btn, nav);
    });
  }

  /* ---------------- reveal on scroll ---------------- */
  function initReveal(root) {
    if (!C.reveal || reduceMotion || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.remove('is-pending'); en.target.classList.add('is-revealed'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.st-reveal', root).forEach(function (el) {
      if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('is-pending'); io.observe(el); }
    });
  }

  /* ---------------- footer accordion ---------------- */
  function initFooter(root) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    $$('.st-footer--accordion details.st-footer__col[open], .st-sf--m-accordion details.st-sf__col[open]', root).forEach(function (d) {
      if (d.dataset.ready) return;
      d.dataset.ready = '1';
      d.open = false;
    });
  }

  /* ---------------- boot ---------------- */
  function init(root) {
    root = root || document;
    initFooter(root);
    initHeader(root);
    initPromo(root);
    initRails(root);
    initSlideshows(root);
    initProducts(root);
    initRecs(root);
    initFacets(root);
    initSearch(root);
    addMenuSearch();
    initReveal(root);
  }
  // ALDO-style dropdown promo tiles (rendered hidden by aldo-core) go into the matching Horizon dropdown
  function handle(str) { return String(str || '').toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function addMegaPromos() {
    var src = $('[data-st-mega-promos]');
    if (!src) return;
    $$('#header-component .menu-list__list-item').forEach(function (li) {
      var title = $('.menu-list__link-title', li);
      var grid = $('.mega-menu__grid', li);
      if (!title || !grid || $('.st-mpromos', grid)) return;
      var set = src.querySelector('[data-for="' + handle(title.textContent) + '"]');
      if (!set) return;
      var box = document.createElement('div');
      box.className = 'st-mpromos';
      box.innerHTML = set.innerHTML;
      grid.appendChild(box);
    });
  }
  // help links + sign in at the bottom of Horizon's mobile menu
  function addDrawerUtility() {
    var tpl = $('template[data-st-drawer-utility]');
    if (!tpl) return;
    $$('#header-component .menu-drawer').forEach(function (drawer) {
      if ($('.st-mm-utility', drawer)) return;
      var nav = $('.menu-drawer__navigation', drawer);
      if (!nav) return;
      nav.parentNode.insertBefore(tpl.content.cloneNode(true), nav.nextSibling);
    });
  }
  onReady(function () {
    addMegaPromos();
    addDrawerUtility();
    // Horizon re-fetches and merges its header after load, which drops anything added to it; put ours back
    var hc = document.getElementById('header-component');
    if (hc && 'MutationObserver' in window) {
      new MutationObserver(debounce(function () { addMegaPromos(); addDrawerUtility(); addMenuSearch(); }, 80)).observe(hc, { childList: true, subtree: true });
    }
  });
  document.addEventListener('shopify:section:load', function () { addMegaPromos(); addDrawerUtility(); });

  // slim header (st-menu-aldo): how far the logo row slides away and how tall the icons are
  function measureHeader() {
    var hc = document.getElementById('header-component');
    if (!hc) return;
    var top = $('.header__row--top', hc);
    var bottom = $('.header__row--bottom', hc);
    if (!top || !bottom) return;
    hc.style.setProperty('--stm-top-h', top.offsetHeight + 'px');
    // page position ignoring any slide already applied, so this works mid-scroll too
    var y = function (el) {
      var t = getComputedStyle(el).transform;
      var dy = t && t !== 'none' && window.DOMMatrixReadOnly ? new DOMMatrixReadOnly(t).m42 : 0;
      return el.getBoundingClientRect().top - dy;
    };
    // how far each column must move down to sit centred in the menu row
    [['.header__row--top .header__column--right', '--stm-icons-shift'], ['.header__row--top .header__column--left', '--stm-logo-shift']].forEach(function (pair) {
      var col = $(pair[0], hc);
      if (!col) return;
      var shift = y(bottom) - y(col) + (bottom.offsetHeight - col.offsetHeight) / 2;
      hc.style.setProperty(pair[1], Math.round(shift) + 'px');
    });
  }
  onReady(measureHeader);
  window.addEventListener('resize', debounce(measureHeader, 150));
  // slim header switches on page scroll position, not Horizon's sticky state: Horizon marks the header
  // "active" whenever it isn't fully on screen, and sliding it up would keep it slim even at the top.
  onReady(function () {
    var hc = document.getElementById('header-component');
    if (!hc || hc.getAttribute('sticky') !== 'always') return;
    var html = document.documentElement;
    var on = false;
    var limit = 0;
    var setLimit = function () {
      if (on) return;
      var quick = $('.st-quick');
      var bottom = (quick && quick.getBoundingClientRect().bottom) || hc.getBoundingClientRect().bottom;
      limit = Math.max(80, bottom + scrollY());
    };
    var check = function () {
      var y = scrollY();
      if (!on && y > limit) { on = true; html.classList.add('st-hdr-slim'); }
      else if (on && y < Math.max(0, limit - 60)) { on = false; html.classList.remove('st-hdr-slim'); }
    };
    setLimit();
    check();
    onPageScroll(check);
    window.addEventListener('resize', debounce(function () { setLimit(); check(); }, 150));
  });
  document.addEventListener('shopify:section:load', measureHeader);

  // Horizon can re-render its mobile menu; put the search field back whenever it opens
  document.addEventListener('click', function (e) {
    if (e.target.closest('.menu-drawer-container > summary, .header__icon--menu')) setTimeout(function () { addMenuSearch(); addDrawerUtility(); }, 0);
  }, true);
  if (C.imageHover !== false) document.documentElement.classList.add('st-img-hover');
  onReady(function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () { S.close(true); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.st-slide');
    if (slide) { var el = slide.closest('[data-st-slideshow]'); $$('.st-slide', el).forEach(function (s) { s.classList.toggle('is-on', s === slide); }); }
    var mega = e.target.closest('.st-nav__item'); if (mega) openMega(mega);
  });
  window.addEventListener('pageshow', function (e) {
    // coming back from checkout with the browser's back button: reset the checkout button
    $$('[data-st-checkout] button.is-loading').forEach(function (b) { b.classList.remove('is-loading'); });
    if (e.persisted) { S.close(true); setHeaderHeight(); }
  });
})();
